const mutations = {
  mutationPolicies(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.policies[payload.tab] = payload.responseData;
    } else {
      state.policies = payload;
    }
  },

  mutationPolicy(state, payload) {
    state.policy = payload;
  },

  mutationClaims(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.claims[payload.tab] = payload.responseData;
    } else {
      state.claims = payload;
    }
  },

  mutationClaim(state, payload) {
    state.claim = payload;
  },

  mutationPoliciesMeta(state, payload) {
    state.policiesMeta = payload;
  },

  mutationClaimsMeta(state, payload) {
    state.claimsMeta = payload;
  },

  mutationListClaimsHistoriesClaim(state, payload) {
    state.claimsHistoriesClaim = payload;
  },

  mutationPartners(state, payload) {
    state.partners = payload;
  },

  mutationProducts(state, payload) {
    state.products = payload;
  },

  mutationProductCategories(state, payload) {
    state.productCategories = payload;
  },

  mutationUploadProgress(state, payload) {
    state.uploadProgress = payload;
  },

  mutationCreatePolicy(state, payload) {
    state.createPolicy = payload;
  },

  mutationProductService(state, payload) {
    state.productService = payload;
  },

  mutationProductServiceBuybackProgram(state, payload) {
    state.productServiceBuybackProgram = payload;
  },

  mutationListBrand(state, payload) {
    state.listBrand = payload;
  },

  mutationListType(state, payload) {
    state.listType = payload;
  },

  mutationCreateClaim(state, payload) {
    state.createClaim = payload;
  },

  mutationIsValidCreateClaim(state, payload) {
    state.isValidCreateClaim = payload;
  },

  mutationQuestionCostEstimation(state, payload) {
    state.questionCostEstimation = payload;
  },

  mutationFilesCostEstimation(state, payload) {
    state.filesCostEstimation = payload;
  },

  mutationExtractImei(state, payload) {
    state.extractImei = payload;
  },

  mutationGetTemplateUrl(state, payload) {
    state.templateUrl = payload;
  },
};

export default mutations;
